import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext } from 'react-router-dom';
import QuillExports from '.././Components/Helpers/QuillHelpers';

const About = () => {
    const { l } = useOutletContext();
    const { SafeHtml } = QuillExports();

    const [section, setSection] = useState(null);
    const [pageContent, setPageContent] = useState({});

    useEffect(() => {
        const fetchAbout = async () => {
            try {
                const response = await MakeRequest(null, `content/pageContent?page=expertise&type=${section}`, 'get');
                if (response.data) {
                    setPageContent(response.data.filter(item => item.type === section)[0] || {});
                }
            } catch (error) {
                console.error('Error fetching retailers:', error);
            }
        };
        fetchAbout();
    }, [section]);

    const sectionTitleMap = {
        'rust-protection': { sv: 'Rostskydd', en: 'Rust Protection' },
        'roof-painting': { sv: 'Takmålning', en: 'Roof Painting' },
        'cultural-heritage': { sv: 'Kulturhistoriska objekt', en: 'Cultural Heritage Objects' },
    };

    useEffect(() => {
        const page = window.location.pathname.split("/").pop();
        setSection(page);
    }, []);

    return (
        <>
            <Container className="my-lg-5 my-3">
                <div className="mb-5">
                    <h1 className="mb-3 fw-bold">
                        {l(sectionTitleMap[section]?.sv, sectionTitleMap[section]?.en)}
                    </h1>
                    <p className="mb-3 mb-md-4 text-break">
                        {l(pageContent.content?.titleSwe, pageContent.content?.titleEng)}
                    </p>
                </div>

                <Row className="g-4 align-items-start">
                    {/* Text first on all sizes */}
                    <Col xs={12} md={6}>
                        <div className="text-break">
                            <SafeHtml html={l(pageContent.content?.sv, pageContent.content?.en)} />
                        </div>
                    </Col>

                    {/* Image stacks below text on small/medium, sits side-by-side ≥ md */}
                    <Col xs={12} md={6}>
                        {pageContent.image && (
                            <img
                                src={pageContent.image}
                                alt="Example"
                                loading="lazy"
                                className="img-fluid w-100 d-block mb-2"
                                style={{ objectFit: 'contain' }}
                            />
                        )}
                    </Col>
                </Row>
            </Container>

        </>
    );
};

export default About;